import React from 'react';

const LegsTypeStep = ({ data, updateData, onNext }) => {
  const types = [
    { id: 'socks', label: 'Socks', image: 'https://assets.fnlfx.com/01JM0EW1VTB5BMA1A4E53S1RS8/8-v0pL.webp' },
    { id: 'pedicure', label: 'Pedicure', image: 'https://assets.fnlfx.com/01JM0EW1VTB5BMA1A4E53S1RS8/h3kXOF.webp' },
    { id: 'long-legs', label: 'Long legs', image: 'https://assets.fnlfx.com/01JM0EW1VTB5BMA1A4E53S1RS8/jrrx55.webp' },
    { id: 'leg-bracelet', label: 'Leg bracelet', image: 'https://assets.fnlfx.com/01JM0EW1VTB5BMA1A4E53S1RS8/CZWd06.webp' }
  ];

  const handleSelect = (typeId) => {
    updateData('legsType', typeId);
    setTimeout(() => onNext(), 300);
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        What kind of legs will your girlfriend have?
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        Select the most exciting option now
      </p>

      <div className="grid grid-cols-2 gap-4">
        {types.map((type) => (
          <button
            key={type.id}
            onClick={() => handleSelect(type.id)}
            className={`group relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105 ${
              data.legsType === type.id ? 'ring-4 ring-[#F1B428]' : ''
            }`}
          >
            <div className="aspect-[5/7] relative bg-[#1A1A1A]">
              <img
                src={type.image}
                alt={type.label}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <span className="text-white text-lg font-semibold">{type.label}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LegsTypeStep;
